import { css } from '@/styled-system/css';

export const estimateContainer = css({
  display: 'flex',
  flexDirection: 'column',
  gap: 'default',
});
